import { ADVANCING_THIRD_PLACE_KEY, GROUP_RANKINGS_KEY, KNOCKOUT_PICKS_KEY, STEP_KEY } from './BracketFormPhaseOne'

export const hasInProgressBracketForm = () => {
  return [
    GROUP_RANKINGS_KEY,
    ADVANCING_THIRD_PLACE_KEY,
    KNOCKOUT_PICKS_KEY,
    STEP_KEY,
  ].some(key => {
    const value = localStorage.getItem(key)
    return value && value !== '{}' && value !== '[]'
  })
}
